module.exports = __webpack_public_path__ + "static/img/16.b2b78f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/16.png
// module id = qZY2
// module chunks = 0